<template>
	<div class="wages wrapper shadow">
		<div class="operation">
			<div class="left">
				<div class="main-title">年度工资汇总表</div>
			</div>
			<div class="right">
				<el-date-picker class="department" v-model="query.year" type="year" placeholder="请选择年度" format="YYYY"
					value-format="YYYY" />
				<el-button type="primary" @click="getList">查询</el-button>
				<el-button type="primary" @click="exportSubmitForm">导出</el-button>
				<el-button type="primary" @click="exportThreeSalaries">导出(三项工资)</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<el-table class="table" header-row-class-name="main-table-header" :data="tableData" border height="670"
			:span-method="objectSpanMethod">
			<el-table-column label="" min-width="150" prop="department" align="center">
			</el-table-column>
			<el-table-column label="" prop="name" align="center"> </el-table-column>
			<el-table-column prop="m1" label="1月" min-width="110" align="center" />
			<el-table-column prop="m2" label="2月" min-width="110" align="center" />
			<el-table-column prop="m3" label="3月" min-width="110" align="center" />
			<el-table-column prop="m4" label="4月" min-width="110" align="center" />
			<el-table-column prop="m5" label="5月" min-width="110" align="center" />
			<el-table-column prop="m6" label="6月" min-width="110" align="center" />
			<el-table-column prop="m7" label="7月" min-width="110" align="center" />
			<el-table-column prop="m8" label="8月" min-width="110" align="center" />
			<el-table-column prop="m9" label="9月" min-width="110" align="center" />
			<el-table-column prop="m10" label="10月" min-width="110" align="center" />
			<el-table-column prop="m11" label="11月" min-width="110" align="center" />
			<el-table-column prop="m12" label="12月" min-width="110" align="center" />
		</el-table>
	</div>
</template>
<script setup>
	import {
		ref
	} from "@vue/reactivity";
	import {
		fetchLastMonth
	} from "@/api/payroll";
	import {
		fetchAnnual
	} from "@/api/report";
	import {
		onMounted
	} from "vue";

	onMounted(() => {
		getLastMonth();
	});

	const getLastMonth = () => {
		fetchLastMonth().then((res) => {
			query.value.year = res.data.split("-")[0];
			getList();
		});
	};

	const getList = () => {
		if (!query.value.year) {
			ElMessage({
				type: "error",
				message: "请选择年度！",
			});
			return;
		}
		fetchAnnual(query.value).then((res) => {
			let data = res.data;
			rawAnnualData.value = data || [];
			handleData(data);
		});
	};

	const THREE_SALARY_ITEMS = ["基本工资", "工龄工资", "绩效工资"];

	const formatMonthValue = (sum) => {
		const n = Math.round((Number(sum) || 0) * 100) / 100;
		if (Math.abs(n - Math.round(n)) < 1e-9) {
			return Math.round(n);
		}
		return n;
	};

	const sumMonthField = (data, department, month, getter) => {
		return data
			.filter((d) => d.department === department && d.month === month)
			.map(getter)
			.reduce((a, b) => a + (Number(b) || 0), 0);
	};

	const sumRowMonths = (row) => {
		let sum = 0;
		for (let i = 1; i <= 12; i++) {
			sum += Number(row["m" + i]) || 0;
		}
		return formatMonthValue(sum);
	};

	const withRowTotal = (row) => {
		row.total = sumRowMonths(row);
		return row;
	};

	const buildThreeSalaryRows = (data) => {
		const departmentList = [];
		data
			.map((e) => e.department)
			.forEach((d) => {
				if (departmentList.indexOf(d) === -1) {
					departmentList.push(d);
				}
			});
		const list = [];
		departmentList.forEach((dept) => {
			const baseRow = { department: dept, name: "基本工资" };
			const seniorityRow = { department: dept, name: "工龄工资" };
			const performanceRow = { department: dept, name: "绩效工资" };
			for (let i = 1; i <= 12; i++) {
				baseRow["m" + i] = formatMonthValue(
					sumMonthField(data, dept, i, (d) => d.baseSalary)
				);
				seniorityRow["m" + i] = formatMonthValue(
					sumMonthField(data, dept, i, (d) => d.annualLeaveAllowance)
				);
				performanceRow["m" + i] = formatMonthValue(
					sumMonthField(
						data,
						dept,
						i,
						(d) =>
							(Number(d.performanceSalary) || 0) +
							(Number(d.subsidy) || 0) +
							(Number(d.otherSalary) || 0) -
							(Number(d.deductions) || 0)
					)
				);
			}
			list.push(withRowTotal(baseRow), withRowTotal(seniorityRow), withRowTotal(performanceRow));
		});
		return list;
	};

	const buildThreeSalaryItemTotals = (rows) => {
		return THREE_SALARY_ITEMS.map((name) => {
			const itemRows = rows.filter((r) => r.name === name);
			const totalRow = { department: "合计", name };
			for (let i = 1; i <= 12; i++) {
				totalRow["m" + i] = formatMonthValue(
					itemRows.reduce((sum, r) => sum + (Number(r["m" + i]) || 0), 0)
				);
			}
			return withRowTotal(totalRow);
		});
	};

	const handleData = (data) => {
		let departmentList = [];
		let list = [];
		data
			.map((e) => e.department)
			.forEach((d) => {
				if (departmentList.indexOf(d) === -1) {
					departmentList.push(d);
				}
			});
		departmentList.forEach((e) => {
			let item1 = {};
			item1.department = e;
			for (let i = 1; i <= 12; i++) {
				item1["name"] = "基本";
				item1["m" + i] = data
					.filter((d) => d.department === e && d.month === i)
					.map((d) => d.baseSalary)
					.reduce((a, b) => a + b, 0).toFixed(2);
				if(item1["m" + i]=='0.00'){
					item1["m" + i]=0
				}
			}
			list.push(item1);
			let item2 = {};
			item2.department = e;
			for (let i = 1; i <= 12; i++) {
				item2["name"] = "工龄";
				item2["m" + i] = data
					.filter((d) => d.department === e && d.month === i)
					.map((d) => d.annualLeaveAllowance)
					.reduce((a, b) => a + b, 0).toFixed(2);
				if(item2["m" + i]=='0.00'){
					item2["m" + i]=0
				}
			}
			list.push(item2);
			let item3 = {};
			item3.department = e;
			for (let i = 1; i <= 12; i++) {
				item3["name"] = "绩效";
				item3["m" + i] = data
					.filter((d) => d.department === e && d.month === i)
					.map((d) => d.performanceSalary)
					.reduce((a, b) => a + b, 0).toFixed(2);
				if(item3["m" + i]=='0.00'){
					item3["m" + i]=0
				}
			}
			list.push(item3);
      let item4 = {};
      item4.department = e;
      for (let i = 1; i <= 12; i++) {
        item4["name"] = "油餐补";
        item4["m" + i] = data
            .filter((d) => d.department === e && d.month === i)
            .map((d) => d.subsidy)
            .reduce((a, b) => a + b, 0).toFixed(2);
        if(item4["m" + i]=='0.00'){
          item4["m" + i]=0
        }
      }
      list.push(item4);
      let item5 = {};
      item5.department = e;
      for (let i = 1; i <= 12; i++) {
        item5["name"] = "其他工资";
        item5["m" + i] = data
            .filter((d) => d.department === e && d.month === i)
            .map((d) => d.otherSalary)
            .reduce((a, b) => a + b, 0).toFixed(2);
        if(item5["m" + i]=='0.00'){
          item5["m" + i]=0
        }
      }
      list.push(item5);
      let item6 = {};
      item6.department = e;
      for (let i = 1; i <= 12; i++) {
        item6["name"] = "社保扣款";
        item6["m" + i] = data
            .filter((d) => d.department === e && d.month === i)
            .map((d) => d.socialSecurity)
            .reduce((a, b) => a + b, 0).toFixed(2);
        if(item6["m" + i]=='0.00'){
          item6["m" + i]=0
        }
      }
      list.push(item6);
      let item7 = {};
      item7.department = e;
      for (let i = 1; i <= 12; i++) {
        item7["name"] = "其他扣款";
        item7["m" + i] = data
            .filter((d) => d.department === e && d.month === i)
            .map((d) => d.deductions)
            .reduce((a, b) => a + b, 0).toFixed(2);
        if(item7["m" + i]=='0.00'){
          item7["m" + i]=0
        }
      }
      list.push(item7);
		});
		let count1 = {};
		count1.department = "总计";
		for (let i = 1; i <= 12; i++) {
			count1["name"] = "基本";
			count1["m" + i] = data
				.filter((d) => d.month === i)
				.map((d) => d.baseSalary)
				.reduce((a, b) => a + b, 0).toFixed(2);
			if(count1["m" + i]=='0.00'){
				count1["m" + i]=0
			}
		}
		list.push(count1);
		let count2 = {};
		count2.department = "总计";
		for (let i = 1; i <= 12; i++) {
			count2["name"] = "工龄";
			count2["m" + i] = data
				.filter((d) => d.month === i)
				.map((d) => d.annualLeaveAllowance)
				.reduce((a, b) => a + b, 0).toFixed(2);
				if(count2["m" + i]=='0.00'){
					count2["m" + i]=0
				}
		}
		list.push(count2);
		let count3 = {};
		count3.department = "总计";
		for (let i = 1; i <= 12; i++) {
			count3["name"] = "绩效";
			count3["m" + i] = data
				.filter((d) => d.month === i)
				.map((d) => d.performanceSalary)
				.reduce((a, b) => a + b, 0).toFixed(2);
			if(count3["m" + i]=='0.00'){
				count3["m" + i]=0
			}
		}
		list.push(count3);
    let count4 = {};
    count4.department = "总计";
    for (let i = 1; i <= 12; i++) {
      count4["name"] = "油餐补";
      count4["m" + i] = data
          .filter((d) => d.month === i)
          .map((d) => d.subsidy)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count4["m" + i]=='0.00'){
        count4["m" + i]=0
      }
    }
    list.push(count4);
    let count5 = {};
    count5.department = "总计";
    for (let i = 1; i <= 12; i++) {
      count5["name"] = "其他工资";
      count5["m" + i] = data
          .filter((d) => d.month === i)
          .map((d) => d.otherSalary)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count5["m" + i]=='0.00'){
        count5["m" + i]=0
      }
    }
    list.push(count5);
    let count6 = {};
    count6.department = "总计";
    for (let i = 1; i <= 12; i++) {
      count6["name"] = "社保扣款";
      count6["m" + i] = data
          .filter((d) => d.month === i)
          .map((d) => d.socialSecurity)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count6["m" + i]=='0.00'){
        count6["m" + i]=0
      }
    }
    list.push(count6);
    let count7 = {};
    count7.department = "总计";
    for (let i = 1; i <= 12; i++) {
      count7["name"] = "其他扣款";
      count7["m" + i] = data
          .filter((d) => d.month === i)
          .map((d) => d.deductions)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count7["m" + i]=='0.00'){
        count7["m" + i]=0
      }
    }
    list.push(count7);
		tableData.value = list;
	};

	//月份
	const query = ref({
		year: "",
	});
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
	import XLSXStyle from "xlsx-js-style";
	import {
		ElMessage
	} from "element-plus";

	const exportSubmitForm = async () => {
		if (tableData.value.length === 0) {
			ElMessage({
				type: "error",
				message: "请先查询数据！",
			});
			return;
		}
		var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
		var wbout = XLSX.write(wb, {
			bookType: "xlsx",
			bookSST: true,
			type: "array",
		});
		try {
			FileSaver.saveAs(
				new Blob([wbout], {
					type: "application/octet-stream"
				}),
				"年度工资汇总总表-" + query.value.year + "年.xlsx"
			);
		} catch (e) {
			if (typeof console !== "undefined") console.log(e, wbout);
		}
		return wbout;
	};

	const exportThreeSalaries = () => {
		if (!rawAnnualData.value.length) {
			ElMessage({
				type: "error",
				message: "请先查询数据！",
			});
			return;
		}
		const year = query.value.year;
		const rows = buildThreeSalaryRows(rawAnnualData.value);
		const itemTotals = buildThreeSalaryItemTotals(rows);
		const exportRows = rows.concat(itemTotals);
		const aoa = [];
		aoa.push([year + "年工资明细表"]);
		aoa.push([
			"部门",
			"项目",
			"1月",
			"2月",
			"3月",
			"4月",
			"5月",
			"6月",
			"7月",
			"8月",
			"9月",
			"10月",
			"11月",
			"12月",
			"合计",
		]);
		exportRows.forEach((row) => {
			aoa.push([
				row.department,
				row.name,
				row.m1,
				row.m2,
				row.m3,
				row.m4,
				row.m5,
				row.m6,
				row.m7,
				row.m8,
				row.m9,
				row.m10,
				row.m11,
				row.m12,
				row.total,
			]);
		});
		const ws = XLSXStyle.utils.aoa_to_sheet(aoa);
		const merges = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 14 } }];
		const deptCount = rows.length / 3;
		for (let i = 0; i < deptCount; i++) {
			const startRow = 2 + i * 3;
			merges.push({
				s: { r: startRow, c: 0 },
				e: { r: startRow + 2, c: 0 },
			});
		}
		if (itemTotals.length) {
			const totalStartRow = 2 + rows.length;
			merges.push({
				s: { r: totalStartRow, c: 0 },
				e: { r: totalStartRow + itemTotals.length - 1, c: 0 },
			});
		}
		ws["!merges"] = merges;
		ws["!cols"] = [
			{ wch: 21.88 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
			{ wch: 12.75 },
		];
		const thinBorder = {
			top: { style: "thin", color: { rgb: "000000" } },
			bottom: { style: "thin", color: { rgb: "000000" } },
			left: { style: "thin", color: { rgb: "000000" } },
			right: { style: "thin", color: { rgb: "000000" } },
		};
		const centerAlign = {
			horizontal: "center",
			vertical: "center",
		};
		const totalRows = aoa.length;
		const totalCols = 15;
		const rowHeights = [];
		for (let R = 0; R < totalRows; R++) {
			rowHeights.push({ hpt: R === 0 ? 25.5 : 39.75 });
			for (let C = 0; C < totalCols; C++) {
				const addr = XLSXStyle.utils.encode_cell({ r: R, c: C });
				if (!ws[addr]) {
					ws[addr] = { t: "s", v: "" };
				}
				ws[addr].s = {
					alignment: centerAlign,
					border: thinBorder,
					font: {
						sz: R === 0 ? 14 : 11,
						name: "宋体",
					},
				};
			}
		}
		ws["!rows"] = rowHeights;
		ws["!ref"] = XLSXStyle.utils.encode_range({
			s: { r: 0, c: 0 },
			e: { r: totalRows - 1, c: totalCols - 1 },
		});
		const wb = XLSXStyle.utils.book_new();
		XLSXStyle.utils.book_append_sheet(wb, ws, "工资明细表");
		const wbout = XLSXStyle.write(wb, {
			bookType: "xlsx",
			bookSST: true,
			type: "array",
		});
		try {
			FileSaver.saveAs(
				new Blob([wbout], {
					type: "application/octet-stream",
				}),
				year + "年工资明细表.xlsx"
			);
		} catch (e) {
			if (typeof console !== "undefined") console.log(e, wbout);
		}
	};

	// 表格
	const tableData = ref([]);
	const rawAnnualData = ref([]);

	const objectSpanMethod = ({
		rowIndex,
		columnIndex
	}) => {
		if (columnIndex === 0) {
			if (rowIndex % 7 === 0) {
				return {
					rowspan: 7,
					colspan: 1,
				};
			} else {
				return {
					rowspan: 0,
					colspan: 0,
				};
			}
		}
	};
</script>
<style lang="scss" scoped>
	.tips {
		line-height: 26px;
	}
</style>
